import Vue from 'vue'
import request from '@/helpers/request'
import store from '@/store'
import moment from 'moment'

export default {
  GET_SETTINGS_COMPANY: ({ commit, state }) => {
    commit('setLoad', true)
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.settingsCompanies.one.replace('$1', 1)}`,
      {},
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setCompanySettings', data)
          return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.employers.priceCategory}`, {}, true)
        } else {
          // TODO: Show error dialog
        }
      })

      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          const employerPriceCategories = data.items

          commit('setEmployerPriceCategories', employerPriceCategories)
          commit('setLoad', false)
        } else {
          // TODO: Show error dialog
        }
      })

      .then(() => {
        return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.employers.category}`, {}, true)
      })
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          const employerCategories = data.items

          _.forEach(employerCategories, employerCategory => {
            const aliasesList = []

            employerCategory.status = null

            const keys = Object.keys(employerCategory.aliases)
            _.forEach(keys, key => {
              const original = moment('2015-01-01').startOf('day').seconds(key).format('HH:mm')

              const modified = moment('2015-01-01')
                .startOf('day')
                .seconds(employerCategory.aliases[key])
                .format('HH:mm')

              aliasesList.push({
                original: original,
                modified: modified,
              })
            })
            employerCategory.aliasesList = aliasesList
          })

          commit('setEmployerCategories', employerCategories)
          commit('setLoad', false)
        } else {
          // TODO: Show error dialog
        }
      })
  },
  UPDATE_SETTINGS_COMPANY: ({ commit, state }) => {
    commit('setLoad', true)

    request(
      'PUT',
      `${Vue.config.server}/${Vue.config.modules.crm.api.settingsCompanies.one.replace('$1', 1)}`,
      {
        rating_rules: state.companySettings.rating_rules,
        rating_min123: state.companySettings.rating_min123,
        rating_block_after: state.companySettings.rating_block_after,
        rating_block_at: state.companySettings.rating_block_at,
        certification_min_score: state.companySettings.certification_min_score,
        rebook_after: state.companySettings.rebook_after,
        rebook_before: state.companySettings.rebook_before,
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          const employerCategories = _.cloneDeep(store.getters.employerCategories)
          const created = []
          const updated = []
          const deleted = []

          _.forEach(employerCategories, employerCategory => {
            // Formatted aliases
            const aliases = {}
            _.forEach(employerCategory.aliasesList, alias => {
              const originalInSeconds = moment(alias.original, 'HH:mm').diff(moment().startOf('day'), 'seconds')
              const modifiedInSeconds = moment(alias.modified, 'HH:mm').diff(moment().startOf('day'), 'seconds')

              aliases[originalInSeconds] = modifiedInSeconds
            })
            employerCategory.aliases = aliases

            // Push to status list
            if (employerCategory.status === Vue.config.employerCategoryStatus.statusCreated) {
              created.push(employerCategory)
            } else if (employerCategory.status === Vue.config.employerCategoryStatus.statusUpdated) {
              updated.push(employerCategory)
            } else if (employerCategory.status === Vue.config.employerCategoryStatus.statusDelete) {
              deleted.push(employerCategory.id)
            }
          })

          return request(
            'POST',
            `${Vue.config.server}/${Vue.config.modules.crm.api.employers.categorySync}`,
            {
              create: created,
              update: updated,
              delete: deleted,
            },
            true,
          )
        } else {
          // TODO: Show error dialog
        }
      })

      .then(response => {
        if (response.data.result === 'success') {
          const employerPriceCategories = _.cloneDeep(store.getters.employerPriceCategories)
          const created = []
          const updated = []
          const deleted = []

          _.forEach(employerPriceCategories, employerPriceCategory => {
            if (employerPriceCategory.status === Vue.config.employerCategoryStatus.statusCreated) {
              created.push(employerPriceCategory)
            } else if (employerPriceCategory.status === Vue.config.employerCategoryStatus.statusUpdated) {
              updated.push(employerPriceCategory)
            } else if (employerPriceCategory.status === Vue.config.employerCategoryStatus.statusDelete) {
              deleted.push(employerPriceCategory.id)
            }
          })

          return request(
            'POST',
            `${Vue.config.server}/${Vue.config.modules.crm.api.employers.priceCategorySync}`,
            {
              create: created,
              update: updated,
              delete: deleted,
            },
            true,
          )
        } else {
          // TODO: Show error dialog
        }
      })

      .then(response => {
        if (response.data.result === 'success') {
          store.dispatch('GET_SETTINGS_COMPANY')

          commit('setLoad', false)

          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'success',
            text: Vue.config.localization.ru.savedMessage,
          })
        } else {
          // TODO: Show error dialog
        }
      })
  },

  GET_BLOCKING_TIME: ({ commit, state }, params) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.settingsCompanies.one.replace('$1', 1)}`,
      {},
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        const begin_at = data.rating_block_at
        const begin_after = data.rating_block_after
        commit('setCompanyBlockAfter', begin_after)
        commit('setCompanyBlockAt', begin_at)

        if (begin_at !== null) {
          commit('setSelectedTypeBlocking', Vue.config.selectedTypesBlocking.blockAt)
        } else if (begin_after !== null) {
          commit('setSelectedTypeBlocking', Vue.config.selectedTypesBlocking.blockAfter)
        } else {
          commit('setSelectedTypeBlocking', Vue.config.selectedTypesBlocking.permanently)
        }
      } else {
        // TODO: Show error dialog
      }
    })
  },
}
